import { Box } from "@jewlr/storybook/core"
import React from "react"
import styled from "styled-components"

import { createsomethingSpecial } from "areas/info/data"

import Cta from "./cta"
import { TitleWithLine } from "./jewlr/components"

const Title = styled(TitleWithLine).attrs({
  as: "h2",
  fontSize: "26px",
  fontWeight: 500,
  lineHeight: "30px",
  px: { _: 3, tablet: 0 },
})``

const Wrapper = styled(Box).attrs((props) => ({
  bg: props.theme.colors.polar,
  mb: { tablet: "-32px" },
  px: 2,
  py: 6,
}))``

const CreatSomethingSpecial = () => (
  <Wrapper>
    <Title>Create Something Special</Title>
    <Cta data={createsomethingSpecial()} />
  </Wrapper>
)

export default CreatSomethingSpecial
